export default "__VITE_ASSET__BqF0WbfG__"